import {
  Box,
  GridLegacy,
  Paper,
  Stack,
  Typography,
  Link as MUILink,
} from "@mui/material";
import { useEasierTheme } from "datalign-themes";
import { FacetFields } from "models/facet-fields";
import React from "react";
import { useNavigate } from "react-router-dom";
import { MaterialIcon } from "ui-widgets";

const SearchBarFacets = ({
  props,
  searchTerm,
  facets,
  handleOpen,
}: {
  props: React.HTMLAttributes<HTMLElement>;
  searchTerm: string;
  facets: FacetFields;
  handleOpen: (open: boolean) => void;
}) => {
  const theme = useEasierTheme();
  const navigate = useNavigate();
  const isFAFTheme = ["FAF-nt"].includes(
    process.env.REACT_APP_STYLING_THEME ?? "",
  );
  return (
    <Paper
      {...props}
      onMouseDown={(e) => {
        e.preventDefault(); // Prevent triggering the default close behavior
        e.stopPropagation(); // Stop event propagation to the parent
      }}
    >
      {searchTerm ? (
        props.children
      ) : (
        <GridLegacy container spacing={2} p={2}>
          <GridLegacy item xs={12} sm={isFAFTheme ? 12 : 6}>
            <Typography variant="subtitle1" color={theme?.Colour.Secondary()}>
              Datatypes
            </Typography>
            <Stack>
              {facets?.Datatypes &&
                facets.Datatypes.map((item, index) => (
                  <Box
                    key={`${index}-${item.field}`}
                    p={1}
                    sx={{ display: "flex" }}
                  >
                    <MaterialIcon icon="filter_alt" />
                    <MUILink
                      component="button"
                      onClick={(e) => {
                        handleOpen(false);
                        navigate(
                          `/search?Datatypes=${encodeURIComponent(item.field)}`,
                        );
                      }}
                      sx={{
                        textAlign: "left",
                        wordWrap: "break-word",
                      }}
                    >
                      {`${item.field} (${item.count})`}
                    </MUILink>
                  </Box>
                ))}
            </Stack>
          </GridLegacy>
          {!isFAFTheme && (
            <GridLegacy item xs={12} sm={6}>
              <Typography variant="subtitle1" color={theme?.Colour.Secondary()}>
                Groups
              </Typography>
              <Stack>
                {facets?.Groups &&
                  facets.Groups.map((item, index) => (
                    <Box
                      key={`${index}-${item.field}`}
                      p={1}
                      sx={{ display: "flex" }}
                    >
                      <MaterialIcon icon="filter_alt" />
                      <MUILink
                        component="button"
                        onClick={(e) => {
                          handleOpen(false);
                          navigate(
                            `/search?Groups=${encodeURIComponent(item.field)}`,
                          );
                        }}
                        sx={{
                          textAlign: "left",
                          wordWrap: "break-word",
                        }}
                      >
                        {`${item.field} (${item.count})`}
                      </MUILink>
                    </Box>
                  ))}
              </Stack>
            </GridLegacy>
          )}
        </GridLegacy>
      )}
    </Paper>
  );
};

export default SearchBarFacets;
